import { Box, Stack, Tooltip } from '@mui/material'
import { Warning } from '@workwave-tidal/core/icons'
import { useIntl } from '@/intl'

type LoadNameProps = {
  name: string
  vehiclesLoads: Set<string>
}

export function LoadName(props: LoadNameProps) {
  const { name, vehiclesLoads } = props
  const { translate } = useIntl()

  if (vehiclesLoads.has(name)) return name

  return (
    <Stack direction="row" gap={0.5}>
      {name}
      <Tooltip
        title={translate({ id: 'order.form.single.field.loads.undefinedLoad.tooltip' })}
        placement="bottom"
        slotProps={{
          popper: {
            sx: { '&[data-popper-placement*="bottom"] .MuiTooltip-tooltip': { mt: 0.5 } },
          },
        }}
      >
        <Box component="span" sx={{ display: 'inline-flex' }}>
          <Warning sx={{ color: t => t.vars.palette.warning.main, width: 16 }} />
        </Box>
      </Tooltip>
    </Stack>
  )
}
